module.exports = __webpack_public_path__ + "img/UTANTE-9.e4c2181a.jpg";